import { prepareChessboard, restrictMove, showMagnus, loadNextConfiguration, showCapturedPieces, hideCapturedPieces } from '../../utils';
import { BLACK_PIECE_SEARCH_KEY, WHITE_INITIAL_MOVE, CORRECT_ANSWER_AUDIO, WRONG_ANSWER_AUDIO } from '../../utils/constants';
import ChessBoard from '../../components/chessBoard';
import $ from 'jquery';
import User from '../../classes/user';

/**
* @name lesson19Assignment
* @function
* @param {config}
* @description: activity related task
*/
export function lesson19Assignment(config) {

  let moveSpeed = 1000,
    next = config.next,
    studentMoves = config.studentMoves,
    fromMoves = config.fromMoves,
    toMove = config.toMove,
    count = 0,
    boardFen,
    capturingPieces = ['bP', 'bN', 'bN', 'bB', 'bR', 'bQ'],
    capturingPiece = 0;

  let afterLoad = function () {
    prepareChessboard(config);
    $('#next').click(function () {
      count = 0;
      capturingPiece = 0;
    })
    $('#previous').click(function () {
      count = 0;
      capturingPiece = 0;
    })
    setTimeout(function () {
      computerMove();
    }, 5000)
  }

  function computerMove(piece) {
    setTimeout(function () {
      ChessBoard.board.move(`${fromMoves[count]}-${toMove}`)
      if (piece) {
        let move = {
          captured: piece.charAt(1),
          color: 'b'
        }
        setTimeout(function () {
          showCapturedPieces(capturingPieces[capturingPiece], move)
          capturingPiece++;
        }, 1000)
      }
      if (count === 6) {
        showMagnus({
          data: 'Wow! That was a lot of captures just on the g4 square!',
          styleClass: 'lg'
        })
        loadNextConfiguration(5000, next, true)
      }
      count++;
      boardFen = ChessBoard.board.fen();
      ChessBoard.board.position(boardFen);
      ChessBoard.game = new window.Chess(boardFen + WHITE_INITIAL_MOVE)
    }, 1000)
  }

  let onDragStart = function (source, piece, position, orientation) {
    return restrictMove(piece, BLACK_PIECE_SEARCH_KEY)
  }

  let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
    let move = ChessBoard.game.move({
      from: source,
      to: target,
    });
    if (move === null) {
      return 'snapback';
    } else {
      if (!move.captured) {
        let boardFen = ChessBoard.board.fen();
        ChessBoard.game = new window.Chess(boardFen + WHITE_INITIAL_MOVE);
        return 'snapback';
      } else {
        showCapturedPieces(piece, move, false)
      }
    }
  }

  var onSnapEnd = function (source, target, piece) {
    if (target === 'g4' && studentMoves.includes(source)) {
      $(document).trigger('audio-play', CORRECT_ANSWER_AUDIO)
      setTimeout(function () {
        computerMove(piece)
      }, 1000)
    }
    else {
      $(document).trigger('audio-play', WRONG_ANSWER_AUDIO)
      showMagnus({
        data: 'wrong move!<br/>Try again!',
        styleClass: 'xs',
        position: 'left'
      })
      setTimeout(function () {
        ChessBoard.board.position(boardFen)
        ChessBoard.game = new window.Chess(boardFen + WHITE_INITIAL_MOVE)
      }, 1000)
    }
  };

  const chessConfig = {
    config: {
      position: config.position,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onSnapEnd: onSnapEnd,
      draggable: true,
      sparePieces: true,
      moveSpeed: moveSpeed
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}

/**
* @name lesson19Assignment2
* @function
* @param {config}
* @description: activity related task
*/

export function lesson19Assignment2(config) {
  let moveSpeed = 1000,
    next = config.next,
    failedMoves = config.failedMove,
    successfullMoves = config.successMove,
    moves = null,
    computerCount = 0, captureCount = 0, studentCount = 0,
    flag = false,
    newPosition = null;

  let afterLoad = function () {
    prepareChessboard(config);
  }

  let onDragStart = function (source, piece, position, orientation) {
    return restrictMove(piece, BLACK_PIECE_SEARCH_KEY)
  }

  $('.next-btn-container #next').click(function () {
    captureCount = 0;
    computerCount = 0;
    studentCount = 0;
    moves = null;
    flag = false;
    newPosition = null;
  });
  $('.back-btn-container #previous').click(function () {
    captureCount = 0;
    computerCount = 0;
    studentCount = 0;
    moves = null;
    flag = false;
    newPosition = null;
  })

  let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
    let move = ChessBoard.game.move({
      from: source,
      to: target
    });
    if (move === null) {
      return 'snapback';
    } else {
      if (move.captured) {
        showCapturedPieces(piece, move, false)
      }
    }
  }

  var onSnapEnd = function (source, target, piece) {
    if (source === 'b1' && target === 'b8' && !flag) {
      moves = failedMoves;
    }
    else if (source === 'e1' && target === 'e8') {
      $('.square-b1').addClass('auto-pointer-event');
      moves = successfullMoves;
      flag = true;
    }
    else if (computerCount === 0) {
      $(document).trigger('audio-play', WRONG_ANSWER_AUDIO)
      showMagnus({
        data: `oops! </br>Try again`,
        position: 'left',
        styleClass: 'xs'
      })
      setTimeout(function () {
        showMagnus({
          data: 'Move the piece to the correct <br/> position.',
          position: 'left',
          styleClass: 'md'
        })
        ChessBoard.board.position(config.position);
        ChessBoard.game = new window.Chess(config.position + WHITE_INITIAL_MOVE);
        return 'snapback';
      }, 3000)
    }
    if (moves) {
      if (studentCount < moves.studentMove.from.length) {
        if (source === moves.studentMove.from[studentCount] && target === moves.studentMove.to[studentCount]) {
          $(document).trigger('audio-play', CORRECT_ANSWER_AUDIO);
          studentCount++;
          computerMove(moves.computerMove);
        }
        else {
          $(document).trigger('audio-play', WRONG_ANSWER_AUDIO)
          showMagnus({
            data: `oops! </br>Try again`,
            position: 'left',
            styleClass: 'xs'
          })
          setTimeout(function () {
            showMagnus({
              data: 'Move the piece to the correct <br/> position.',
              position: 'left',
              styleClass: 'md'
            })
            ChessBoard.board.position(newPosition);
            ChessBoard.game = new window.Chess(newPosition + WHITE_INITIAL_MOVE);
            return 'snapback';
          }, 2000)

        }
      }
    }
    let boardFen = ChessBoard.board.fen();
    if (boardFen === config.resultFen) {
      showMagnus({
        data: 'Nice job! </br> White is up by three points.',
        styleClass: 'md'
      })
      captureCount = 0;
      computerCount = 0;
      studentCount = 0;
      moves = null;
      flag = false;
      newPosition = null;
      loadNextConfiguration(3000, next, true);
    }
  };

  function computerMove(computerMove) {
    ChessBoard.board.move(`${computerMove.from[computerCount]}-${computerMove.to[computerCount]}`);
    if (moves.captureComputerMove) {
      if (captureCount === 0) {
        let move = {
          captured: moves.captureComputerMove.capturedPiece[captureCount][1],
          color: moves.captureComputerMove.capturingPiece[captureCount].charAt(0)
        }
        setTimeout(function () {
          showCapturedPieces(moves.captureComputerMove.capturingPiece[captureCount], move, false)
        }, moveSpeed)
      }
      captureCount++;
    }
    computerCount++;
    setTimeout(function () {
      if (computerMove.from.length === 1) {
        showMagnus({
          data: 'That wasn’t White’s best choice.Now try it with the other Rook first.',
          styleClass: 'xl'
        })
        $('.square-b1').addClass('none-pointer-event');
        computerCount = 0;
        studentCount = 0;
        captureCount = 0;
        moves = null;
        flag = true;
        hideCapturedPieces()
        ChessBoard.board.position(config.position);
        ChessBoard.game = new window.Chess(config.position + WHITE_INITIAL_MOVE);
        return 'snapback';
      }
    }, 2000)
    newPosition = ChessBoard.board.fen();
    ChessBoard.board.position(newPosition);
    ChessBoard.game = new window.Chess(newPosition + WHITE_INITIAL_MOVE);
  }

  const chessConfig = {
    config: {
      position: config.position,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onSnapEnd: onSnapEnd,
      draggable: true,
      sparePieces: true,
      moveSpeed: moveSpeed
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}

/**
* @name lesson19Activity3
* @function
* @param {config}
* @description: activity 3 lesson 19
*/

export function lesson19Assignment3(config) {
  let moveSpeed = 1000,
    next = config.next,
    finalMoves,
    studentCount, computerCount, captureCount,
    newPosition, flag;

  let afterLoad = function () {
    prepareChessboard(config);
    studentCount = 0;
    computerCount = 0;
    captureCount = 0;
    newPosition = null;
    flag = false;
    finalMoves = null;
  }

  let onDragStart = function (source, piece, position, orientation) {
    return restrictMove(piece, BLACK_PIECE_SEARCH_KEY)
  }

  $('.next-btn-container #next').click(function () {
    captureCount = 0;
    computerCount = 0;
    studentCount = 0;
    finalMoves = null;
    newPosition = null;
    flag = false;
  });

  $('.back-btn-container #previous').click(function () {
    captureCount = 0;
    computerCount = 0;
    studentCount = 0;
    finalMoves = null;
    newPosition = null;
    flag = false;
  })

  let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
    let move = ChessBoard.game.move({
      from: source,
      to: target
    });
    if (move === null) {
      return 'snapback';
    } else {
      if (move.captured) {
        showCapturedPieces(piece, move, false)
      }
    }
  }

  var onSnapEnd = function (source, target, piece) {
    let boardFen = ChessBoard.board.fen();
    if ((config.result).includes(boardFen)) {
      showMagnus({
        data: 'Nice job!' + User.user.name,
        styleClass: 'xs'
      })
      setTimeout(function () {
        captureCount = 0;
        computerCount = 0;
        studentCount = 0;
        finalMoves = null;
        newPosition = null;
        flag = false;
      }, 2000)
      loadNextConfiguration(2000, next, true);
    }
    if (source === 'a6' && target === 'c8' && !flag) {
      finalMoves = config.bishop1Moves;
    }
    else if (source === 'g3' && target === 'e5' && !flag) {
      finalMoves = config.bishop2Moves;
    }
    else if (!flag) {
      $(document).trigger('audio-play', WRONG_ANSWER_AUDIO);
      ChessBoard.board.position(config.position);
      ChessBoard.game = new window.Chess(config.position + WHITE_INITIAL_MOVE);
      return 'snapback';
    }
    if (finalMoves) {
      flag = true;
      if (studentCount < finalMoves.studentMove.from.length) {
        if (source === finalMoves.studentMove.from[studentCount] && target === finalMoves.studentMove.to[studentCount]) {
          $(document).trigger('audio-play', CORRECT_ANSWER_AUDIO);
          studentCount++;
          computerMove(finalMoves.computerMove);
        }
        else {
          $(document).trigger('audio-play', WRONG_ANSWER_AUDIO)
          showMagnus({
            data: `oops! </br>Try again`,
            position: 'left',
            styleClass: 'xs'
          })
          setTimeout(function () {
            showMagnus({
              data: 'Move the piece to the correct <br/> position.',
              position: 'left',
              styleClass: 'md'
            })
            ChessBoard.board.position(newPosition);
            ChessBoard.game = new window.Chess(newPosition + WHITE_INITIAL_MOVE);
            return 'snapback';
          }, 2000)
        }
      }
    }
  }

  function computerMove(computerMove) {
    ChessBoard.board.move(`${computerMove.from[computerCount]}-${computerMove.to[computerCount]}`);
    if (finalMoves.captureComputerMove) {
      if (captureCount === 0) {
        let move = {
          captured: finalMoves.captureComputerMove.capturedPiece[captureCount][1],
          color: finalMoves.captureComputerMove.capturingPiece[captureCount].charAt(0)
        }
        setTimeout(function () {
          showCapturedPieces(finalMoves.captureComputerMove.capturingPiece[captureCount], move, false)
        }, moveSpeed)
        captureCount++;
      }
    }
    computerCount++;
    newPosition = ChessBoard.board.fen();
    ChessBoard.board.position(newPosition);
    ChessBoard.game = new window.Chess(newPosition + WHITE_INITIAL_MOVE);
  }

  const chessConfig = {
    config: {
      position: config.position,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onSnapEnd: onSnapEnd,
      draggable: true,
      sparePieces: true,
      moveSpeed: moveSpeed
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}


/**
* @name lesson19Activity3
* @function
* @param {config}
* @description: to fill squares with stars
*/
export function lesson19Activity3(config) {
  let square = config.starSquares;
  let afterLoad = function () {
    prepareChessboard(config);
    $(function () {
      $('.answer').click(function (e) {
        e.preventDefault();
        square.forEach(element => {
          $(element).append('<img class="star-img" src="/img/star.png" />')
        })
      })
    })
  }

  const chessConfig = {
    config: {
      position: config.position
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}



// WEBPACK FOOTER //
// ./src/lessons/lesson_19/assignments.js